// extracted by mini-css-extract-plugin
export default {"chartRoot":"FeedbackGroupViewCard_chartRoot__YaS3U"};